// extracted by mini-css-extract-plugin
export default {"LeagueTable":"style_LeagueTable__sKQ5l","fileName":"style_fileName__91d0y"};